import Cookies from 'js-cookie';

import { constants } from '../config';

export function readUserLanguage() {
  const language = Cookies.get('language') || Cookies.get('locale') || 'en';

  if (constants.languages.includes(language)) {
    return language;
  }

  return 'en';
}

export function getTranslatedLocaleUrls(urls: string[], locale: string): string[] {
  return urls.map((url) => {
    if (constants.languages.includes(locale)) {
      return url.replace('.en.', `.${locale}.`);
    }

    return url;
  });
}

export const fetchTranslations = async (urls: string[]) => {
  const fetchPromises = urls.map((url) => fetch(url).then((response) => response.json()));

  const translationsArray = await Promise.all(fetchPromises);

  const mergedTranslations = translationsArray.reduce((acc, translation) => {
    return { ...acc, ...translation };
  }, {});

  return mergedTranslations;
};
